export default class Expenditure {
  public constructor (init?:Partial<Expenditure>) {
    Object.assign(this, init)
  }

  public id: string | null = null;
  public quantity: number | null = null;
  public position: string | null = null;
  public positionPrice: number | null = null;
  public totalPrice: number | null = null;
  public trackingId: string | null = null;
}
